import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {Trans} from '@common/i18n/trans';
import React, {Fragment, ReactNode} from 'react';
import {FormSelect} from '@common/ui/forms/select/select';
import {Item} from '@common/ui/forms/listbox/item';
import { FormDatePicker } from '@common/ui/forms/input-field/date/date-picker/date-picker';
import { useSettings } from '@common/core/settings/use-settings';
import { useMyLenders } from '@app_modules/admin/lenders/requests/use-my-lenders';
import { Lender } from '@app_modules/lenders/lender';

export function CrupdateChatForm() {
  
  const {data: mylenders} = useMyLenders();
  const lenders = mylenders?.lenders;

  return (
    <Fragment>
      <FormTextField
        name="name"
        label={<Trans message="Name" />}
        className="mb-20"
        required
        autoFocus
      />

      <FormSelect
        name="lender_id"
        selectionMode="single"
        required
        label={<Trans message="Lender" />}
        className="mb-20"
      >
        {lenders?.map((lender: Lender) => (
        <Item value={lender.id} key={lender.id}>
          <Trans message={lender.name} />
        </Item>
        ))}
      </FormSelect>
      
    </Fragment>
  );
}

interface HeaderProps {
  children: ReactNode;
}
function Header({children}: HeaderProps) {
  return <h2 className="mt-40 mb-20 text-base font-semibold">{children}</h2>;
}


